import React, { useState, useEffect } from "react";
import brand_logo from "../../assets/img/logo.svg";

import {ReactComponent as PinIcon} from "../../assets/img/icon/pin.svg";
import {ReactComponent as FileIcon} from "../../assets/img/icon/file-plus.svg";
import { ReactComponent as TicketIcon } from "../../assets/img/icon/ticket.svg";
import Supplier_En from "../../assets/img/ticket__create/supplier_en.svg";
import Supplier_He from "../../assets/img/ticket__create/supplier_he.svg";

import profile_user from "../../assets/img/new__user/user_profile.svg";
import buttom_arrow from "../../assets/img/new__user/bottom-arrow.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { fetchSupplierStatus } from "Redux/middlwares/suppliers";
import { STATUS, PACKAGE_STATUS, STATUS_CODES } from "Constants/ticket-creator";
import price_icon from "../../assets/img/icon/price.svg";
import Login from "./login";
import CreateNewUser from "Components/new-order/create-new-user";
import { useTranslation } from "react-i18next";
import "./header.scss";

function Header({showLoginOption=true,setCheckLogout}) {
  const userData = useAppSelector(state => state.user.userData);
  const userImg = useAppSelector((state) => state.user.profilePicture);
  const [showLogin, setShowLogin] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userModalShow, setUserModalShow] = useState(false);
  const { t } = useTranslation(['common', 'header']);
  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);
  const supplierStatus = useAppSelector((state) => state.supplier.supplierStatus);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isSupplier = supplierStatus !== STATUS_CODES.NOT_FOUND &&
    supplierStatus?.status === STATUS.APPROVED &&
    supplierStatus?.package_status === PACKAGE_STATUS.OPERATIONAL;

  useEffect(() => {
    if (userData && supplierStatus && typeof supplierStatus === 'object' && supplierStatus.status === undefined) {
      dispatch(fetchSupplierStatus());
    }
  }, [userData, supplierStatus, dispatch]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMobileMenuOpen(false);
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [mobileMenuOpen]);

  return (
    <>
    <header id="head">
      <nav id="navbar" className="w-100 py-3 py-lg-0">
        <div className="container-fluid">
          <div className={"row" + (rightToLeft ? " rightToLeft" : "")}>
            {/* <!-- brand and order links */}
            <div className="header-bar">            
              <div
                className="
                            header-links
                            pl-4
                            pr-4
                            d-flex
                            align-items-center
                        "
              >
                <Link to="/new-order"> 
                  <img
                    className="brand__icon"
                    src={brand_logo}
                    alt="brand icon"
                  />
                </Link>
              </div>
              <button
                type="button"
                className="mobile-nav-toggle d-lg-none"
                aria-label={t('menu', { ns: 'header' })}
                aria-expanded={mobileMenuOpen}
                aria-controls="mobile-navigation"
                onClick={() => setMobileMenuOpen(true)}
              >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </button>
                <NavLink
                  to="/new-order"
                  className="
                              d-none d-lg-flex
                              align-items-lg-center
                              col-3 col-xxl-2
                              py-lg-3 text-muted
                          "
                  activeClassName="active__mark"
                  exact
                >
                  <FileIcon />
                  <p
                    className="
                                  order__text
                                  text-uppercase
                                  d-inline-block
                                  ms-2
                              "
                  >
                    {t('new order', {ns: 'header'})}
                  </p>
                </NavLink>
              {userData &&
              <>
                <NavLink
                  to="/my-order"
                  className="
                              d-none d-lg-flex
                              align-items-lg-center
                              col-3 col-xxl-2
                              py-lg-3 text-muted
                        "
                  activeClassName="active__mark"
                  exact
                >
                  <PinIcon />
                  <p
                    className="
                                  order__text
                                  text-uppercase
                                  d-inline-block
                                  ms-2
                              "
                  >
                    {t('my orders', {ns: 'header'})}
                  </p>
                </NavLink>
                {isSupplier && (
                  <NavLink to="/price-list" className="d-none d-lg-flex align-items-lg-center col-2 py-lg-3 text-muted" activeClassName="active__mark" exact>
                    <img src={price_icon} alt="" style={{ width: 20, height: 20 }} />
                    <p className="order__text text-uppercase d-inline-block ms-2">{t("nav", { ns: "supplierPricing" })}</p>
                  </NavLink>
                )}
                <NavLink
                  to="/ticket-creator"
                  className="
                              d-none d-lg-flex
                              align-items-lg-center
                              align-items-center
                              col-4 col-xxl-3
                              py-lg-3 text-muted
                        "
                  activeClassName="active__mark"
                  exact
                >
                  <TicketIcon />
                  <p
                    className="
                                  order__text
                                  text-uppercase
                                  d-inline-block
                                  ms-2
                              "
                    style={{
                      fontSize: "15px"
                    }}
                  >
                    {t('ticket creator', {ns: 'header'})}
                  </p>
                  <span>
                    {
                      rightToLeft ? (
                        <img style={{width: "48px", height: "21px", marginBottom: "2px"}} src={Supplier_He} alt="Ticket Creator He" />
                      ):(
                        <img style={{width: "57px", height: "19px", paddingLeft: "8px", marginBottom: "3px"}} src={Supplier_En} alt="Ticket Creator En" />
                      )
                    }
                  </span>
                </NavLink>
              </>
              }
            </div>
            {/* <!-- user section  --> */}
            <div
              className="
                            user__section
                            d-none d-lg-flex
                            user-profile
                            justify-content-lg-end
                        "
            >
              {showLoginOption && userData ?
                <>
                <div
                  className="user d-flex flex-row align-items-center"
                  // type="button"
                  data-toggle="collapse"
                  data-target="#userArea"
                  aria-expanded="false"
                  aria-controls="userArea"
                  style={{cursor: 'pointer'}}
                > 
                {
                  userImg ? (
                    <div 
                      className={"img__bg" + (rightToLeft ? " img_ml":" img_mr")} 
                    >
                      <img
                        src={userImg}
                        className="user__pic"
                        alt="profile user icon"
                      />    
                    </div>
                  ):(
                    <img
                    className="user__img"
                    src={profile_user}
                    alt="profile user icon"
                  />
                  )
                }
                  <h3 className={"text-uppercase text-white mb-0 " + (rightToLeft && userImg ? "mr-0" : "")}>{userData.first_name} {userData.last_name}</h3>
                  <img className="arrow" src={buttom_arrow} alt="" />
                </div>
                {/* <!----------------- user area ---------------------  --> */}
                <div className={"collapse" + (rightToLeft ? " rightToLeft" : "")} id="userArea">
                  <ul className="list-group bg-dark">
                    <li className="
                                          list-group-item
                                          bg-dark
                                          text-center
                                          text-capitalize
                                          
                                      "><Link className="text-decoration-none text-white" to="/view-profile">{t('my profile', {ns: 'header'})}</Link></li>
                    <li
                      onClick={()=>setCheckLogout(true)}
                      className="
                                          list-group-item
                                          bg-dark
                                          text-center
                                          text-capitalize
                                          text-white
                                      "
                    >
                      {t('logout', {ns: 'header'})}
                    </li>
                  </ul>
                </div>
                {/* <!-- ------------------ user area -------------------------> */}
                </>
                :
                <div
                  className="user d-flex flex-row align-items-center"
                  // type="button"
                  data-toggle="collapse"
                  data-target="#userArea"
                  aria-expanded="false"
                  aria-controls="userArea"
                >
                  <button className="btn text-uppercase text-white" onClick={() => setShowLogin(true)}>
                    {t('login', {ns: 'header'})}
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </nav>
      {showLoginOption && (
        <>
          <button
            type="button"
            className={"mobile-nav-backdrop d-lg-none" + (mobileMenuOpen ? " is-open" : "")}
            aria-label={t('menu', { ns: 'header' })}
            tabIndex={mobileMenuOpen ? 0 : -1}
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside
            id="mobile-navigation"
            className={"mobile-nav-drawer d-lg-none" + (mobileMenuOpen ? " is-open" : "") + (rightToLeft ? " is-rtl" : "")}
            aria-hidden={!mobileMenuOpen}
          >
            <div className="mobile-nav-heading">
              <div>
                <span className="mobile-nav-eyebrow">{t('menu', { ns: 'header' })}</span>
                {userData && <strong>{userData.first_name} {userData.last_name}</strong>}
              </div>
              <button type="button" className="mobile-nav-close" aria-label="Close" onClick={() => setMobileMenuOpen(false)}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <nav className="mobile-nav-links" aria-label={t('menu', { ns: 'header' })}>
              <NavLink to="/new-order" exact activeClassName="is-active">
                <FileIcon /><span>{t('new order', { ns: 'header' })}</span>
              </NavLink>
              {userData && (
                <>
                  <NavLink to="/my-order" exact activeClassName="is-active">
                    <PinIcon /><span>{t('my orders', { ns: 'header' })}</span>
                  </NavLink>
                  {isSupplier && (
                    <NavLink to="/price-list" exact activeClassName="is-active">
                      <img src={price_icon} alt="" /><span>{t('nav', { ns: 'supplierPricing' })}</span>
                    </NavLink>
                  )}
                  <NavLink to="/ticket-creator" exact activeClassName="is-active">
                    <TicketIcon /><span>{t('ticket creator', { ns: 'header' })}</span>
                  </NavLink>
                  <NavLink to="/view-profile" exact activeClassName="is-active">
                    <img src={profile_user} alt="" /><span>{t('my profile', { ns: 'header' })}</span>
                  </NavLink>
                </>
              )}
            </nav>
            <div className="mobile-nav-footer">
              {userData ? (
                <button type="button" className="mobile-nav-session-action" onClick={() => { setMobileMenuOpen(false); setCheckLogout(true); }}>
                  {t('logout', { ns: 'header' })}
                </button>
              ) : (
                <button type="button" className="mobile-nav-session-action" onClick={() => { setMobileMenuOpen(false); setShowLogin(true); }}>
                  {t('login', { ns: 'header' })}
                </button>
              )}
            </div>
          </aside>
        </>
      )}
    </header>
    { showLoginOption && !userData &&
      <>
        <Login show={showLogin}  onHide={() => setShowLogin(!showLogin)} />
        <CreateNewUser
          show={userModalShow}
          openLogin={() => setShowLogin(true)}
          onHide={() => setUserModalShow(false)}
        />
      </>
    }
    </>
  );
}

export default Header;
